import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBadge,{attrs:{"color":"red","value":_vm.content,"content":_vm.content,"overlap":""}},[_c(VBtn,{attrs:{"dark":"","icon":"","text":"","to":{name:'CustomerOrderPage'}}},[_c(VIcon,[_vm._v("shopping_cart")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }